import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

/**appConfig: configure how routes work with modules, components, other routes */
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
